import React from "react";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Correct from "../../img/correct.jpg";
import { checkLastName } from "../../utils/validations";

function LastName({ form, setForm, setFocusOnInput = () => {} }) {
  const { t } = useTranslation();
  return (
    <>
      <TextField
        onFocus={() => {
          setFocusOnInput(true);
        }}
        onClick={(event) => {
          event.stopPropagation();
        }}
        inputProps={{ autocomplete: "new-password" }}
        size="small"
        error={!form.lastName.valid}
        helperText={!form.lastName.valid && t("invalid_name")}
        className="homeMobile__filling__content__input"
        label={"Last Name"}
        variant="outlined"
        value={form.lastName.value}
        onChange={(event) => {
          var format =
            /[0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`·～！¥（）—】【」「、｜；：’‘“”？》。《，]+/g;
          var value = event.target.value;
          value = value.replace(format, "");
          if (value?.length > form.lastName.max) {
            value = value.slice(0, form.lastName.max);
          }
          setForm((prev) => {
            return {
              ...prev,
              lastName: { ...prev.lastName, value: value },
            };
          });
        }}
        onBlur={() => {
          checkLastName({ form: form, setForm: setForm });
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <img
                src={Correct}
                alt=""
                style={{
                  display:
                    form.lastName.valid && form.lastName.checked
                      ? "block"
                      : "none",
                }}
              />
            </InputAdornment>
          ),
        }}
      />
    </>
  );
}

export default LastName;
